import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
const _c0 = function () {
  return ["/home"];
};
export class ProfileComponent {}
ProfileComponent.ɵfac = function ProfileComponent_Factory(t) {
  return new (t || ProfileComponent)();
};
ProfileComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: ProfileComponent,
  selectors: [["ng-component"]],
  decls: 180,
  vars: 4,
  consts: [[1, "dashboard-wrapper"], [1, "row"], [1, "col-12"], ["translate", ""], ["aria-label", "breadcrumb", 1, "pt-0", "breadcrumb-container", "d-none", "d-sm-block", "d-lg-inline-block"], [1, "breadcrumb"], [1, "breadcrumb-item"], ["aria-current", "page", 1, "active", 3, "routerLink"], ["aria-current", "page", 1, "active", "breadcrumb-item"], [1, "separator", "mb-5"], [1, "col-lg-12"], [1, "icon-cards-row"], [1, "react-siema-container"], [2, "width", "711.5px", "transition", "all 200ms ease-out 0s", "transform", "translate3d(0px, 0px, 0px)"], [1, "icon-row-item", 2, "float", "left", "width", "25%"], [1, "mb-4", "card"], [1, "text-center", "card-body"], [1, "iconsmind-Alarm"], [1, "card-text", "font-weight-semibold", "mb-0"], [1, "lead", "text-center"], [1, "iconsmind-Basket-Coins"], [1, "iconsmind-Arrow-Refresh"], [1, "iconsmind-Mail-Read"], [1, "mb-4", "col-sm-12", "col-md-6"], [1, "dashboard-filled-line-chart", "card"], [1, "card-body"], [1, "float-left", "float-none-xs"], [1, "d-inline-block"], [1, "d-inline"], [1, "text-muted", "text-small", "d-block"], [1, "btn-group", "float-right", "float-none-xs", "mt-2"], [1, "dropdown"], ["type", "button", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn-xs", "dropdown-toggle", "btn", "btn-outline-primary"], ["tabindex", "-1", "role", "menu", "aria-hidden", "true", 1, "dropdown-menu", "dropdown-menu-right"], ["type", "button", "tabindex", "0", 1, "dropdown-item"], [1, "chart", "card-body", "pt-0"], [1, "chartjs-size-monitor"], [1, "chartjs-size-monitor-expand"], [1, ""], [1, "chartjs-size-monitor-shrink"], ["height", "194", "width", "646", 1, "chartjs-render-monitor", 2, "display", "block", "width", "646px", "height", "194px"], ["type", "button", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn-xs", "dropdown-toggle", "btn", "btn-outline-secondary"], [1, "mb-4", "col-lg-4"], [1, "progress-banner", "card"], [1, "justify-content-between", "d-flex", "flex-row", "align-items-center", "card-body"], [1, "iconsmind-Alarm", "mr-2", "text-white", "align-text-bottom", "d-inline-block"], [1, "lead", "text-white"], [1, "text-small", "text-white"], [1, "progress-bar-circle", "progress-bar-banner", "position-relative"], ["viewBox", "0 0 100 100", 1, "CircularProgressbar"], ["d", "\n      M 50,50\n      m 0,-48\n      a 48,48 0 1 1 0,96\n      a 48,48 0 1 1 0,-96\n    ", "stroke-width", "4", "fill-opacity", "0", 1, "CircularProgressbar-trail", 2, "stroke-dasharray", "301.593px, 301.593px", "stroke-dashoffset", "0px"], ["d", "\n      M 50,50\n      m 0,-48\n      a 48,48 0 1 1 0,96\n      a 48,48 0 1 1 0,-96\n    ", "stroke-width", "4", "fill-opacity", "0", 1, "CircularProgressbar-path", 2, "stroke-dasharray", "301.593px, 301.593px", "stroke-dashoffset", "180.956px"], ["x", "50", "y", "50", 1, "CircularProgressbar-text"], [1, "iconsmind-Male", "mr-2", "text-white", "align-text-bottom", "d-inline-block"], ["d", "\n      M 50,50\n      m 0,-48\n      a 48,48 0 1 1 0,96\n      a 48,48 0 1 1 0,-96\n    ", "stroke-width", "4", "fill-opacity", "0", 1, "CircularProgressbar-path", 2, "stroke-dasharray", "301.593px, 301.593px", "stroke-dashoffset", "102.542px"], [1, "iconsmind-Bell-2", "mr-2", "text-white", "align-text-bottom", "d-inline-block"], ["d", "\n      M 50,50\n      m 0,-48\n      a 48,48 0 1 1 0,96\n      a 48,48 0 1 1 0,-96\n    ", "stroke-width", "4", "fill-opacity", "0", 1, "CircularProgressbar-path", 2, "stroke-dasharray", "301.593px, 301.593px", "stroke-dashoffset", "60.3186px"]],
  template: function ProfileComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "h1")(4, "span", 3);
      i0.ɵɵtext(5, "Account");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(6, "nav", 4)(7, "ol", 5)(8, "li", 6)(9, "a", 7)(10, "span");
      i0.ɵɵtext(11, "Home");
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(12, "li", 6)(13, "a", 7)(14, "span");
      i0.ɵɵtext(15, "Dashboard");
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(16, "li", 8)(17, "span");
      i0.ɵɵtext(18, "Content");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelement(19, "div", 9);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(20, "div", 1)(21, "div", 10)(22, "div", 11)(23, "div", 12)(24, "div", 13)(25, "div", 14)(26, "div", 15)(27, "div", 16);
      i0.ɵɵelement(28, "i", 17);
      i0.ɵɵelementStart(29, "p", 18)(30, "span");
      i0.ɵɵtext(31, "Pending Orders");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(32, "p", 19);
      i0.ɵɵtext(33, "14");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(34, "div", 14)(35, "div", 15)(36, "div", 16);
      i0.ɵɵelement(37, "i", 20);
      i0.ɵɵelementStart(38, "p", 18)(39, "span");
      i0.ɵɵtext(40, "Completed Orders");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(41, "p", 19);
      i0.ɵɵtext(42, "32");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(43, "div", 14)(44, "div", 15)(45, "div", 16);
      i0.ɵɵelement(46, "i", 21);
      i0.ɵɵelementStart(47, "p", 18)(48, "span");
      i0.ɵɵtext(49, "Refund Requests");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(50, "p", 19);
      i0.ɵɵtext(51, "74");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(52, "div", 14)(53, "div", 15)(54, "div", 16);
      i0.ɵɵelement(55, "i", 22);
      i0.ɵɵelementStart(56, "p", 18)(57, "span");
      i0.ɵɵtext(58, "New Comments");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(59, "p", 19);
      i0.ɵɵtext(60, "25");
      i0.ɵɵelementEnd()()()()()()()()();
      i0.ɵɵelementStart(61, "div", 1)(62, "div", 23)(63, "div", 24)(64, "div", 25)(65, "div", 26)(66, "div", 27)(67, "h5", 28)(68, "span");
      i0.ɵɵtext(69, "Website Visits");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(70, "span", 29)(71, "span");
      i0.ɵɵtext(72, "Unique Visitors");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(73, "div", 30)(74, "div", 31)(75, "button", 32)(76, "span");
      i0.ɵɵtext(77, "This Week");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(78, "div", 33)(79, "button", 34)(80, "span");
      i0.ɵɵtext(81, "Lat Week");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(82, "button", 34)(83, "span");
      i0.ɵɵtext(84, "This Month");
      i0.ɵɵelementEnd()()()()()();
      i0.ɵɵelementStart(85, "div", 35)(86, "div", 36)(87, "div", 37);
      i0.ɵɵelement(88, "div", 38);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(89, "div", 39);
      i0.ɵɵelement(90, "div", 38);
      i0.ɵɵelementEnd()();
      i0.ɵɵelement(91, "canvas", 40);
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(92, "div", 23)(93, "div", 24)(94, "div", 25)(95, "div", 26)(96, "div", 27)(97, "h5", 28)(98, "span");
      i0.ɵɵtext(99, "Conversion Rates");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(100, "span", 29)(101, "span");
      i0.ɵɵtext(102, "Per Session");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(103, "div", 30)(104, "div", 31)(105, "button", 41)(106, "span");
      i0.ɵɵtext(107, "This Week");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(108, "div", 33)(109, "button", 34)(110, "span");
      i0.ɵɵtext(111, "Lat Week");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(112, "button", 34)(113, "span");
      i0.ɵɵtext(114, "This Month");
      i0.ɵɵelementEnd()()()()()();
      i0.ɵɵelementStart(115, "div", 35)(116, "div", 36)(117, "div", 37);
      i0.ɵɵelement(118, "div", 38);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(119, "div", 39);
      i0.ɵɵelement(120, "div", 38);
      i0.ɵɵelementEnd()();
      i0.ɵɵelement(121, "canvas", 40);
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(122, "div", 1)(123, "div", 42)(124, "div", 43)(125, "div", 44)(126, "div");
      i0.ɵɵelement(127, "i", 45);
      i0.ɵɵelementStart(128, "div")(129, "p", 46);
      i0.ɵɵtext(130, " 5 ");
      i0.ɵɵelementStart(131, "span");
      i0.ɵɵtext(132, "Posts");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(133, "p", 47)(134, "span");
      i0.ɵɵtext(135, "Pending for publish");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(136, "div", 48);
      i0.ɵɵnamespaceSVG();
      i0.ɵɵelementStart(137, "svg", 49);
      i0.ɵɵelement(138, "path", 50)(139, "path", 51);
      i0.ɵɵelementStart(140, "text", 52);
      i0.ɵɵtext(141, "5/12");
      i0.ɵɵelementEnd()()()()()();
      i0.ɵɵnamespaceHTML();
      i0.ɵɵelementStart(142, "div", 42)(143, "div", 43)(144, "div", 44)(145, "div");
      i0.ɵɵelement(146, "i", 53);
      i0.ɵɵelementStart(147, "div")(148, "p", 46);
      i0.ɵɵtext(149, " 4 ");
      i0.ɵɵelementStart(150, "span");
      i0.ɵɵtext(151, "Users");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(152, "p", 47)(153, "span");
      i0.ɵɵtext(154, "On approval process");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(155, "div", 48);
      i0.ɵɵnamespaceSVG();
      i0.ɵɵelementStart(156, "svg", 49);
      i0.ɵɵelement(157, "path", 50)(158, "path", 54);
      i0.ɵɵelementStart(159, "text", 52);
      i0.ɵɵtext(160, "4/6");
      i0.ɵɵelementEnd()()()()()();
      i0.ɵɵnamespaceHTML();
      i0.ɵɵelementStart(161, "div", 42)(162, "div", 43)(163, "div", 44)(164, "div");
      i0.ɵɵelement(165, "i", 55);
      i0.ɵɵelementStart(166, "div")(167, "p", 46);
      i0.ɵɵtext(168, " 8 ");
      i0.ɵɵelementStart(169, "span");
      i0.ɵɵtext(170, "Alerts");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(171, "p", 47)(172, "span");
      i0.ɵɵtext(173, "Waiting for notice");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(174, "div", 48);
      i0.ɵɵnamespaceSVG();
      i0.ɵɵelementStart(175, "svg", 49);
      i0.ɵɵelement(176, "path", 50)(177, "path", 56);
      i0.ɵɵelementStart(178, "text", 52);
      i0.ɵɵtext(179, "8/10");
      i0.ɵɵelementEnd()()()()()()()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(9);
      i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(2, _c0));
      i0.ɵɵadvance(4);
      i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(3, _c0));
    }
  },
  dependencies: [i1.RouterLink],
  encapsulation: 2
});